import type { SVGProps } from 'react'
const SvgSyArrowRightDownSystem = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="M20.1 17.3 3.3.7 1 3l16.7 16.7H5.1V23h18.2V4.7H20v12.6z" />
	</svg>
)
export default SvgSyArrowRightDownSystem
